import { useCallback, useSyncExternalStore } from "react";
import { useApiStore } from "@finitless/shared/stores";
import {
  getRun,
  isRunExpired,
  resolveRunStatus,
  subscribe,
} from "@/lib/menuImportRuns";

/**
 * Last import run for the active project and one source.
 * Stale and expiry rules are applied when reading: no timer.
 * A resolved run older than a day reads as no run at all.
 */
export const useMenuImportRun = (source) => {
  const project = useApiStore((state) => state.project);
  const read = useCallback(
    () => getRun({ project, source }),
    [project, source],
  );
  const run = useSyncExternalStore(subscribe, read);
  if (!run || isRunExpired(run)) return null;
  const status = resolveRunStatus(run);
  return status === run.status ? run : { ...run, status };
};
